/** 일정계획 API 날짜 — 로컬 기준 YYYY-MM-DD (UTC toISOString 사용 금지) */
export function normalizeScheduleDate(value: unknown): string {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value.split('T')[0];
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  return String(value).split('T')[0];
}

export function mapSchedulePlanRows<T extends { clsp_date?: unknown; clsp_caregiver_birth?: unknown }>(
  rows: T[]
): T[] {
  return rows.map((row) => ({
    ...row,
    clsp_date: normalizeScheduleDate(row.clsp_date),
    clsp_caregiver_birth: row.clsp_caregiver_birth
      ? normalizeScheduleDate(row.clsp_caregiver_birth)
      : row.clsp_caregiver_birth,
  }));
}
